var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('AreaChart',{attrs:{"sourceData":_vm.dynamic,"title":_vm.title}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }